import { PublicClientApplication } from "@azure/msal-browser";

const msalConfig = {
    auth: {
        // eslint-disable-next-line no-underscore-dangle
        clientId: `${window.__RUNTIME_CONFIG__?.CLIENT_ID}`,
        // eslint-disable-next-line no-underscore-dangle
        authority: `https://login.microsoftonline.com/${window.__RUNTIME_CONFIG__?.TENANT_ID}`,
        // eslint-disable-next-line no-underscore-dangle
        redirectUri: window.__RUNTIME_CONFIG__?.REDIRECT_URI,
    },
    cache: {
        cacheLocation: "localStorage",
        storeAuthStateInCookie: true,
    },
};

export const msalInstance = new PublicClientApplication(msalConfig);
await msalInstance.initialize();
